import { Box, Collapse, Typography } from '@mui/material';
import { CaretUp } from 'phosphor-react';
import { Fragment, useEffect, useState } from 'react';

type Props = {
  item: {
    title: string;
    path?: string;
    icon?: JSX.Element;
    endIcon?: JSX.Element;
    breadCrumbs?: {
      title: string;
      selected?: boolean;
      onClick?: () => void;
    }[];
  };
  activePage?: string;
  selected?: boolean;
  onClick?: () => void;
};

const LayoutItems = ({ item, selected, onClick }: Props) => {
  const breadcrumbOpenInitial = !!item.breadCrumbs && !!selected;
  const [breadcrumbOpen, setBreadcrumbOpen] = useState(breadcrumbOpenInitial);

  return (
    <Fragment>
      <Box
        key={item.title}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        onClick={() => {
          !!onClick && onClick();
          !!item.breadCrumbs && setBreadcrumbOpen(!breadcrumbOpen);
        }}
        padding={'10px 22px'}
        bgcolor={!!selected ? '#E5FAFF' : ''}
        borderRadius={'4px'}
        sx={{
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: '#E5FAFF',
          },
        }}
      >
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          width={'100%'}
          alignItems={'center'}
          gap={'8px'}
        >
          <Box display={'flex'} alignItems={'center'} gap={'10px'}>
            {item.icon}
            <Typography
              variant='body1'
              sx={{
                maxWidth: '200px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                textDecoration: 'none',
                color: !!selected ? '#202A2D' : '#655C68',
                fontWeight: '600',
                fontSize: '16px',
                lineHeight: '20px',
                whiteSpace: 'nowrap',
              }}
            >
              {item.title}
            </Typography>
          </Box>
          {item.endIcon}
        </Box>
        {item.breadCrumbs && item.breadCrumbs.length > 0 && (
          <CaretUp
            style={{
              cursor: 'pointer',
              transform: breadcrumbOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        )}
      </Box>
      <Collapse in={breadcrumbOpen}>
        <Box
          sx={{
            maxHeight: '130px',
            overflowY: 'scroll',
            '::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          {item.breadCrumbs?.map((breadcrumb, index) => (
            <Box position={'relative'} key={index}>
              <Box
                ml={'60px'}
                sx={{
                  '&:before': {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    left: '30px',
                    width: '15px',
                    height: '1px',
                    backgroundColor: '#E3DDE6',
                  },

                  '&:after': {
                    content: '""',
                    position: 'absolute',
                    top:
                      index + 1 === item.breadCrumbs?.length ? '-20px' : '0 ',
                    left: '30px',
                    width: '1px',
                    height:
                      index + 1 === item.breadCrumbs?.length ? '30px' : '50px ',
                    backgroundColor: '#E3DDE6',
                    borderRadius: '50%',
                  },
                }}
              >
                <Box
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  onClick={breadcrumb.onClick}
                  mb={'20px'}
                  borderRadius={'4px'}
                  sx={{
                    cursor: 'pointer',
                  }}
                >
                  <Box display={'flex'} alignItems={'center'} gap={'10px'}>
                    <Typography
                      variant='body1'
                      sx={{
                        textDecoration: 'none',
                        color: !!breadcrumb.selected ? '#3293DB' : '#655C68',
                        fontWeight: 500,
                        fontSize: '16px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '150px',
                        ':hover': {
                          color: '#3293DB',
                        },
                      }}
                      title={breadcrumb.title}
                    >
                      {breadcrumb.title}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Collapse>
    </Fragment>
  );
};

export default LayoutItems;
